import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { id: "cart" }
const _hoisted_2 = { id: "cart-content" }
const _hoisted_3 = { class: "cart-main" }
const _hoisted_4 = { class: "cart-item-left" }
const _hoisted_5 = { class: "cart-image-box" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "cart-item-name" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "cart-item-right" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "cart-item-quantity" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "cart-item-quantity-under" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 0,
  class: "under-meta"
}
const _hoisted_18 = {
  key: 1,
  class: "under-meta"
}
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "cart-total" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Cart Total: ")
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "shipping-total" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", null, "Checkout", -1)
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cartItems, (count, id) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "cart-item",
          key: id
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (this.productInfo[id])
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      class: "cart-image",
                      src: _ctx.galleryImage(this.productInfo[id].images[0])
                    }, null, 8, _hoisted_6))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              (this.productInfo[id])
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(this.productInfo[id].name), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", null, [
                (this.productInfo[id])
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, " USD$" + _toDisplayString((this.productInfo[id].price / 100).toFixed(2)) + " / each ", 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", {
                  onClick: ($event: any) => (_ctx.decreaseQuantity(id)),
                  class: "quantity-button quantity-left"
                }, "◀", 8, _hoisted_12),
                _createElementVNode("div", null, _toDisplayString(count), 1),
                _createElementVNode("div", {
                  onClick: ($event: any) => (_ctx.increaseQuantity(id)),
                  class: "quantity-button quantity-right"
                }, "▶", 8, _hoisted_13)
              ]),
              _createElementVNode("div", null, [
                (this.productInfo[id])
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, " USD$" + _toDisplayString((this.productInfo[id].price * count / 100).toFixed(2)) + " total ", 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", {
              onClick: ($event: any) => (_ctx.decreaseQuantity(id)),
              class: "quantity-button quantity-left"
            }, "◀", 8, _hoisted_16),
            (this.productInfo[id])
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, " USD$" + _toDisplayString((this.productInfo[id].price / 100).toFixed(2)) + " / each ", 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, _toDisplayString(count), 1),
            (this.productInfo[id])
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, " USD$" + _toDisplayString((this.productInfo[id].price * count / 100).toFixed(2)) + " total ", 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              onClick: ($event: any) => (_ctx.increaseQuantity(id)),
              class: "quantity-button quantity-right"
            }, "▶", 8, _hoisted_19)
          ])
        ]))
      }), 128)),
      _createElementVNode("div", _hoisted_20, [
        _hoisted_21,
        (!(this.loadingCount === 0))
          ? (_openBlock(), _createElementBlock("span", _hoisted_22, "Calculating..."))
          : _createCommentVNode("", true),
        (this.loadingCount === 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_23, "USD$" + _toDisplayString((_ctx.totalValue / 100).toFixed(2)), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_24, [
        (!(this.loadingCount === 0))
          ? (_openBlock(), _createElementBlock("span", _hoisted_25, "Calculating..."))
          : _createCommentVNode("", true),
        (this.loadingCount === 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_26, " Shipping: USD$" + _toDisplayString((_ctx.shippingValue / 100).toFixed(2)), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", {
        class: "cart-checkout",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.checkout && _ctx.checkout(...args)))
      }, [
        _hoisted_27,
        _createElementVNode("div", null, [
          (!(this.loadingCount === 0))
            ? (_openBlock(), _createElementBlock("span", _hoisted_28, "Calculating..."))
            : _createCommentVNode("", true),
          (this.loadingCount === 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_29, "USD$" + _toDisplayString(((_ctx.totalValue + _ctx.shippingValue) / 100).toFixed(2)), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}